export const footerId = {
  licenses: 'footerLicenses',
};
